<template>
  <div>
    <GmapMap
      :center="{
        lat: Number(bngLat),
        lng: Number(bngLng),
      }"
      :zoom="7"
      map-type-id="terrain"
      :style="{ width: '100%', height: `${height}` + 'px' }"
    >
      <GmapMarker
        :key="s._id"
        v-for="s in validStations"
        :position="s.GPS"
        :clickable="true"
        :icon="{
          url: stationIcon(s),
          size: { width: 60, height: 48, f: 'px', b: 'px' },
          scaledSize: { width: 60, height: 48, f: 'px', b: 'px' },
        }"
        @click="toStatus(s)"
      >
        <GmapInfoWindow :key="s.name" :position="s.GPS">
          {{ s.name }}
        </GmapInfoWindow>
        <GmapCircle
          :key="s._id"
          :center="s.GPS"
          :radius="7000"
          :visible="true"
          :options="{
            strokeColor: `${colorStation(s.stage)}`,
            strokeOpacity: 0.05,
            strokeWeight: 10,
            fillColor: `${colorStation(s.stage)}`,
            fillOpacity: 0.05,
          }"
        ></GmapCircle>
      </GmapMarker>

      <GmapMarker
        :key="t._id"
        v-for="t in validTrucks"
        :position="{
          lat: Number(t.truck.latitude),
          lng: Number(t.truck.longitude),
        }"
        :clickable="true"
        :icon="{
          url: require(`../../../public/img/icon/trucks.png`),
          size: { width: 96, height: 48, f: 'px', b: 'px' },
          scaledSize: { width: 96, height: 48, f: 'px', b: 'px' },
        }"
        @click="toStatus(t)"
      >
        <GmapInfoWindow
          :key="t.licenseplate"
          :position="{
            lat: Number(t.truck.latitude),
            lng: Number(t.truck.longitude),
          }"
        >
          {{ t.licenseplate }}
        </GmapInfoWindow>
        <GmapCircle
          :center="{
            lat: Number(t.truck.latitude),
            lng: Number(t.truck.longitude),
          }"
          :radius="7000"
          :visible="true"
          :options="{
            strokeColor: '#013D81',
            strokeOpacity: 0.05,
            strokeWeight: 10,
            fillColor: '#013D81',
            fillOpacity: 0.05,
          }"
        ></GmapCircle>
      </GmapMarker>
    </GmapMap>
  </div>
</template>

<script>
const ICON_NAMES = ["16", "24", "booster", "centrifugal", "doublebooster"];

export default {
  props: ["stations", "trucks", "bngLat", "bngLng", "height"],

  computed: {
    validStations() {
      return (this.stations || []).filter(
        (s) => s && s.GPS && s.GPS.lat != null && s.GPS.lng != null
      );
    },
    validTrucks() {
      return (this.trucks || []).filter(
        (t) =>
          t && t.truck && t.truck.latitude != null && t.truck.longitude != null
      );
    },
  },

  methods: {
    stationIcon(s) {
      const name =
        s.type && s.type.name && ICON_NAMES.includes(s.type.name)
          ? s.type.name
          : "24";
      return require(`../../../public/img/icon/${name}.png`);
    },
    colorStation(stage) {
      switch (stage) {
        case "Ready":
          return "#013D81";
        case "Working" || "01":
          return "#078847";
        case "Warning Alarm":
          return "#f48010";
        case "Shutdown Alarm" || "02":
          return "#FF0000";
      }
    },
    toStatus(s) {
      let ID = "";
      if (s.station) {
        ID = s.station.id;
      } else if (s.id) {
        ID = s.id;
      } else {
        ID = s._id;
      }
      this.$router.push({ path: "/station/status/" + ID });
    },
  },
};
</script>

<style lang="scss" scoped></style>
